import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({name: 'arrayTostringJoin'})
export class ArrayTostringJoinPipe implements PipeTransform {
  constructor(
    private translate: TranslateService
  ) {

  }

  transform(value: any[], separator?: string): string {
    let temp = [];
    value.forEach((ele) => {
      if (typeof ele === 'object') {
        const transVal = this.translate.instant(ele.value);
        temp.push(transVal);
      } else {
        const transVal = this.translate.instant(ele);
        temp.push(transVal);
      }
    })
    return temp.join(separator);
  }
}